export const MARSTONE_ERROR_TEXT = 'Something went wrong, Unable to redirect to New Account Opening Screen';
export const MARSTONE_LOADING_TEXT = 'Please wait.. You are being redirected to New Account Opening Screen';
